import { render } from "./addzone_page.vue?vue&type=template&id=01651d57"
import script from "./addzone_page.vue?vue&type=script&lang=js"
export * from "./addzone_page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__